import {Link, useHistory} from 'react-router-dom';
import React, {FC} from "react";
import 'react-toastify/dist/ReactToastify.css';
import IconDoc from "../../assets/images/icons/document.png";
import IconInvoice from '../../assets/images/invoice.png';
import IconNote from '../../assets/images/note.png';

const Home: FC = () => {
    return (
        <>
            <div className='card-header'>
                {/*<img style={{display: 'block', margin: "auto"}}
                     src='https://s3.amazonaws.com/haika-assets-production/logos/18/original/haika.png?1374163459'
                     alt=''/>
                <br/>*/}
                <div className='text-center'>
                    <span><h4>Bienvenido al servicio de facturación</h4></span>
                </div>
                <br/>
                <div className='text-center'>
                    <span><strong>Instrucciones: </strong>Selecccione la opcion de acuerdo al tipo de documento con el que cuenta.</span>
                </div>
            </div>
            <div className='card-body align-center'>
                <div className="row h-100">
                    <div className="card col-md-6 align-center">
                        <div className="card-body">
                            <Link className='btn btn-outline-primary btn-sm btn-block h-100' to='/sale'>
                                <strong>
                                    Generar Factura
                                </strong>
                                <div className={'row'}>
                                    <img src={IconNote} alt=''/>
                                </div>
                                <div>
                                    <img width={'16px'} src={IconDoc} alt=''/>
                                    <span>    </span>
                                    Nota de Remisión o Ticket de Compra
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="card col-md-6">
                        <div className="card-body">
                            <Link className='btn btn-outline-primary btn-sm btn-block text-center h-100' to='/sinvoice'>
                                <strong>
                                    Consultar Factura
                                </strong>
                                <div className={'row text-center h-auto'}>
                                    <img  src={IconInvoice} alt=''/>
                                </div>
                                <div className={'text-center w-100'} style={{position: 'absolute', bottom: 0}}>
                                    <img width={'16px'} src={IconDoc} alt=''/>
                                    <span>    </span>
                                    Factura Electronica
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;
